import React from 'react'
import SharedVisitFilterModal from '../common/SharedVisitFilterModal.jsx'
import { AUTHORIZE_FILTER_KEY } from '../../util/visitFilters'

const defaultFilters = {
  SAID: '',
  memberNo: '',
  patientName: '',
  monthYear: '',
  recentDays: '42',
}
const AuthorizeFilterModal = (props) => (
  <SharedVisitFilterModal
    {...props}
    storageKey={AUTHORIZE_FILTER_KEY}
    title="Filter Authorization Visits"
    defaultFilters={defaultFilters}
    showActiveCriterionHelper
    notifyOnClear={false}
  />
)

export default AuthorizeFilterModal
